import { makeAutoObservable } from 'mobx';
import type PulseApi from '../../../../../api/PulseApi';
import type AuthStore from '../../../../login/store/AuthStore';
import type Bill from './Bill';

export default class BillingStore {
  constructor(
    private readonly api: PulseApi,
    private readonly authStore: AuthStore,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  getBillUrl(bill: Bill): string {
    if (!bill.isValid) {
      return '';
    }

    return this.api.utils.getBillingUrl(
      bill.provider?.id,
      bill.startDate.toISOString(),
      bill.endDate.toISOString(),
    );
  }

  downloadBill(bill: Bill) {
    const idToken = this.authStore.session?.idToken;
    const href = this.getBillUrl(bill);
    if (!href || !idToken) {
      return;
    }

    const url = new URL(href);
    url.searchParams.set('idToken', idToken);
    window.open(url.href, '_blank');
  }
}
